import React, {Component} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {change, Field} from 'redux-form';
import {connect} from 'react-redux';
import {compose} from 'recompose';
import {RESOURCES as productResources} from '../fuseProductsResourceMap';
import {checkTokenStatus} from '../shared/tokenFunctions';
import VirtualizedSelectInput from '../components/VirtualizedSelectInput';

/**
 * A SelectInput component with Product Type choices populated with names, with optional additional choices.
 *
 */
class ProductTypesSelectInput extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectChoices: [],
            selectedId: null,
        };

        this.assembleChoices = this.assembleChoices.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
    }

    componentDidMount() {
        this.setState({
            selectedId: ''
        });
        if (this.props.onSelectChange) {
            this.props.onSelectChange(this.props.formName, this.props.source, '');
        }
        this.props.dispatch(change(this.props.formName, this.props.source, ''));
        this.fetchData();
    }

    fetchData() {
        // Assemble the URI
        const params = {
            filter: {},
            pagination: {page: 1, perPage: 10000},
            sort: {field: "name", order: "ASC"}
        };
        const resource = productResources.ProductTypes.GET_LIST(params);

        // Retrieve the data and assign results to the Select choices
        import('../shared/functions')
            .then(functions => {
                const tokenStatus = checkTokenStatus(null);
                if (tokenStatus.expired) {
                    return;
                }
                axios({
                    method: 'get',
                    url: resource.uri,
                    headers: functions.getGetHeaders()
                }).then((result) => {
                    if (result.data.payload) {
                        let choices = this.assembleChoices(result.data.payload);
                        this.setState({
                            selectChoices: choices
                        });
                    }
                }).catch((error) => {
                    if (error.response) {
                        // Server response outside 2xx
                        console.log(error.response.data);
                    } else if (error.request) {
                        // No response
                        console.log(error.request);
                    } else {
                        console.log('Error', error.message);
                    }
                });
            });
    }

    assembleChoices(choices) {
        // Set select label: ID - Name
        for (let choice of choices) {
            choice.display_name = (choice.name) ? choice.name : choice.id;
        }
        // If additional choices should be added, note them here
        if (this.props.additionalChoices && this.props.additionalChoices.length > 0) {
            for (let i = 0; i < this.props.additionalChoices.length; i++) {
                const additional = this.props.additionalChoices[i];
                const choice = {
                    display_name: additional.display_name,
                    id: additional.id,
                    name: additional.name
                };
                if (additional.first) {
                    choices.unshift(choice);
                } else {
                    choices.push(choice);
                }
            }
        }
        return choices;
    }

    handleSelectChange(event, index) {
        const selectedId = index;
        // Retrieve the choice from the choices list based on the selected ID
        if (selectedId) {
            const selection = this.state.selectChoices.find(p => p.id === selectedId);
            if (selection) {
                this.setState({
                    selectedId: selectedId
                });
                if (this.props.onSelectChange) {
                    this.props.onSelectChange(this.props.formName, this.props.source, selection.id);
                }
                this.props.dispatch(change(this.props.formName, this.props.source, selection.id));
            }
        } else {
            this.setState({
                selectedId: ''
            });
            if (this.props.onSelectChange) {
                this.props.onSelectChange(this.props.formName, this.props.source, '');
            }
            this.props.dispatch(change(this.props.formName, this.props.source, ''));
        }
    }

    render() {
        return (
            <span>
                <Field name={this.props.source}
                       component={VirtualizedSelectInput}
                       choices={this.state.selectChoices}
                       label={this.props.label}
                       optionText="display_name"
                       optionValue="name"
                       onChange={this.handleSelectChange}
                       required={this.props.isRequired}
                       allowEmpty
                       options={{
                           clearable: false,
                           placeholder: this.props.label,
                           required: this.props.isRequired,
                       }}
                />
            </span>
        );
    }
}

ProductTypesSelectInput.propTypes = {
    addField: PropTypes.bool.isRequired,
    additionalChoices: PropTypes.array,
    formName: PropTypes.string,
    isRequired: PropTypes.bool,
    onSelectChange: PropTypes.func,
    selectedId: PropTypes.string,
    source: PropTypes.string,
};

ProductTypesSelectInput.defaultProps = {
    addField: true,
    additionalChoices: [],
    formName: 'record-form',
    isRequired: false,
    selectedId: null,
    source: "type"
};

const enhance = compose(
    connect()
);

export default enhance(ProductTypesSelectInput);



// WEBPACK FOOTER //
// ./src/Fuse/components/ProductTypesSelectInput.js